import { APICall } from "."

const controllerName = "2fa"

export const Initiate2FA = (X2FA: string) => {
    return APICall("post", `/auth/${controllerName}/enroll/init`, undefined,
        {
            headers: { "X-2FA-Token": X2FA },
        }
    )
}

export const Confirm2FA = (X2FA: string, body: { code: string }) => {
    return APICall("post", `/auth/${controllerName}/enroll/confirm`, body,
        {
            headers: { "X-2FA-Token": X2FA },
        }
    )
}

export const Verify2FACode = (X2FA: string, body: { code: string }) => {
    return APICall("post", `/auth/${controllerName}/verify`, body,
        {
            headers: { "X-2FA-Token": X2FA },
        }
    )
}
